// extracted by mini-css-extract-plugin
export default {"MasterPage2":"page2Component_MasterPage2__qAkcr","ChartsPageMaster":"page2Component_ChartsPageMaster__qqu3c"};